import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-facebook-ads-checklist',
  templateUrl: './help-facebook-ads-checklist.component.html'
})
export class HelpFacebookAdsChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
